import React from 'react';
import { AutoResizer } from 'react-base-table';
import { useDispatch, useSelector } from 'react-redux';
import { listLoadingSelector, scheduleListSelector } from '@store/policies/schedule/selectors';
import { isEmpty } from 'lodash';
import { Retry } from '@components/common';
import { setSortBy } from '@store/policies/schedule/actions';
import ActionCell from './ActionCell';
import { formatDate, formatStatus, formatUsername } from './utils';
import { TableWrapper, StyledBaseTable } from './styled';

const columns: any = [
  {
    title: 'Policies',
    key: 'policyNames',
    dataKey: 'policyNames',
    width: 0,
    align: 'left',
    flexGrow: 1,
    sortable: true,
  },
  {
    title: 'Trigger At',
    key: 'triggerAt',
    dataKey: 'triggerAt',
    width: 200,
    align: 'left',
    dataGetter: formatDate,
    sortable: true,
  },
  {
    title: 'Notes',
    key: 'notes',
    dataKey: 'notes',
    width: 0,
    align: 'left',
    flexGrow: 1,
    sortable: true,
  },
  {
    title: 'Status',
    key: 'state',
    dataKey: 'state',
    dataGetter: formatStatus,
    width: 120,
    align: 'left',
    sortable: true,
  },
  {
    title: 'Last Updated',
    key: 'updatedAt',
    dataKey: 'updatedAt',
    width: 200,
    align: 'left',
    dataGetter: formatDate,
    sortable: true,
  },
  {
    title: 'Updated By',
    key: 'username',
    dataKey: 'username',
    width: 200,
    align: 'left',
    dataGetter: formatUsername,
    sortable: true,
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 120,
    align: 'left',
    cellRenderer: ({ rowData }) => <ActionCell rowData={rowData} />,
  },
];

function Table({ fetchData, canEdit }) {
  const dispatch = useDispatch();
  const { data, sortBy } = useSelector(scheduleListSelector);
  const { loading, showError } = useSelector(listLoadingSelector);
  const onColumnSort = ({ key, order }) => {
    // dispatch here
    dispatch(setSortBy({ key, order }));
  };

  if (!canEdit) {
    columns.find((c) => c.key === 'actions').hidden = true;
  }

  return (
    <TableWrapper>
      <Retry
        isLoading={loading}
        showError={showError}
        isEmpty={isEmpty(data)}
        mountChildAlways={false}
        fetchData={fetchData}
      >
        <AutoResizer>
          {({ width, height }) => (
            <StyledBaseTable
              data={data}
              columns={columns}
              headerHeight={30}
              rowHeight={45}
              fixed={false}
              width={width}
              height={height}
              sortBy={sortBy}
              onColumnSort={onColumnSort}
            />
          )}
        </AutoResizer>
      </Retry>
    </TableWrapper>
  );
}

export default Table;
